import { Button, CircularProgress, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PosicaoFilaAgendamentoResponse } from '../../../interfaces/entities/PAVirtual/PosicaoFilaAgendamentoResponse';
import { StepIngressarAtendProps } from '../../../interfaces/props/SaudeOnline/IngressarNoAtendimento/StepIngressarAtendProps';
import { getPosicaoFilaAgendamento } from '../../../services/SaudeOnlineService';
import { getCurrentTime } from '../../../utils/TimeUtils';
import ModalCancelarAtendimento from '../MeusAgendamentos/ModalCancelarAtendimento';
import HeaderTelessaude from './HeaderTelessaude';
import './styles.css';
import './sxProps';
import { sxButtonTelessaudeAtendOutlined, sxTypographyQueueInfoDescription, sxTypographyQueueInfoTitle, sxTypographyTelessaudeSubtitle, sxTypographyQInfoTele } from './sxProps';

const FilaPAVirtual: React.FC<StepIngressarAtendProps> = ({ ...props }) => {

  const { nextStep, idAgenda, fillIdReuniaoPaVirtual } = { ...props };
  const [inQueue, setInQueue] = useState<boolean>(true);
  const [showModalCancelarAtendimento, setShowModalCancelarAtendimento] = useState<boolean>(false);
  const [horaAtualizado, setHoraAtualizado] = useState<string>(getCurrentTime());
  const [posicaoFilaAgendamento, setPosicaoFilaAgendamento] = useState<string>('');
  const [refreshQueuePosition, setRefreshQueuePosition] = useState<boolean>(true);
  const navigate = useNavigate();

  const handleClickCancelarAtendimento = () => {
    setShowModalCancelarAtendimento(showModalCancelarAtendimento => !showModalCancelarAtendimento);
  }

  const handleScheduleStarted = (idReuniao: string) => {
    setRefreshQueuePosition(false);
    fillIdReuniaoPaVirtual!(idReuniao);
    nextStep();
  }

  const fetchPosicaoAgendamento = async () => {
    const result = await getPosicaoFilaAgendamento(idAgenda!);
    if (result?.status === 200) {
      const responseFilaAgendamento: PosicaoFilaAgendamentoResponse = result.data;
      let numberPosicaoFila: number = parseInt(responseFilaAgendamento.posicao, 10);
      let numberIdReuniaoZoom: number = parseInt(responseFilaAgendamento.idReuniaoZoom, 10);
      if (numberPosicaoFila === 0 && numberIdReuniaoZoom !== 0) {
        handleScheduleStarted(responseFilaAgendamento.idReuniaoZoom);
      } else if (numberPosicaoFila === 0) {
        handleOutOfQueue();
      }
      setPosicaoFilaAgendamento(responseFilaAgendamento.posicao);
      setHoraAtualizado(getCurrentTime());
    } else {
      console.error('Falha ao atualizar posição da fila', result);
    }
  }

  const handleOutOfQueue = () => {
    setInQueue(false);
  }

  useEffect(() => {

    fetchPosicaoAgendamento();

    const refreshInterval = 1 * 30 * 1000; //30 segundos
    const intervalId = setInterval(() => {
      if (refreshQueuePosition) {
        fetchPosicaoAgendamento();
      }
    }, refreshInterval);

    return () => clearInterval(intervalId);
  }, []);

  const getQueueInfoDescription = () => {
    return inQueue
      ? <>Caso não acesse a consulta em até <b>3 minutos</b>, a sala virtual será liberada para o próximo paciente da fila.</>
      : <>Caso tenha problemas de conexão durante o atendimento, você pode acessar a videochamada novamente entrando no <b>PA Virtual Unimed Ágil</b> ou em <b>Ingressar Atendimento</b>.</>
  }

    const getInfoTele = () => {
    return  <>Caso possua exames, tenha os resultados em mãos para seu atendimento.</>
      
  }

  const getInQueueMessage = () => {
    let numberPosicaoFila: number = parseInt(posicaoFilaAgendamento, 10);
    return numberPosicaoFila > 0
      ? `Você é o ${posicaoFilaAgendamento}º da fila de espera. Por favor, aguarde.`
      : 'Atendimento cancelado';
  }

  return (
    <>
      <div className='telessaude-space-between-content'>
        <div className='telessaude-gap-content'>
          <HeaderTelessaude />
          <Typography width={'60%'} textAlign={'center'} sx={sxTypographyTelessaudeSubtitle}>
            {inQueue ? 'SALA DE ESPERA' : 'AGORA É SUA VEZ!'}
          </Typography>
          <Typography width={'60%'} textAlign={'center'}>
            {inQueue ? getInQueueMessage() : 'Em instantes, iremos liberar o seu acesso à videochamada'}
          </Typography>
          <CircularProgress style={{ color: 'white !important' }} className='queue-circular-progress-margin-top' color={'inherit'} thickness={5} size={50} />
        </div>
        <div className='telessaude-gap-content'>

          <div className='queue-info-container-tele'>            
            <Typography sx={sxTypographyQInfoTele}>{getInfoTele()}</Typography>
          </div>
          <Typography fontSize={'14px'}>atualizado às {horaAtualizado}</Typography>
          <div className='queue-info-container'>
            <Typography sx={sxTypographyQueueInfoTitle}>ATENÇÃO:</Typography>
            <Typography sx={sxTypographyQueueInfoDescription}>{getQueueInfoDescription()}</Typography>
          </div>
          {!inQueue && <div style={{ height: '40px' }} />}
          {inQueue &&
          <div className='space-bottom'>
            <Button                   
              type='button'
              variant='outlined'
              sx={sxButtonTelessaudeAtendOutlined}
              onClick={handleClickCancelarAtendimento}
            >
              <Typography>Cancelar Atendimento</Typography>
            </Button>
            </div>}
        </div>
      </div>
      <ModalCancelarAtendimento
        agendamento={null} handleShowModal={handleClickCancelarAtendimento}
        onComplete={() => navigate('/home')} showModal={showModalCancelarAtendimento}
        idAgendaPaVirtual={idAgenda}
      />
    </>
  )
}

export default FilaPAVirtual;